import clsx from 'clsx'
import {CampaignChannel} from '../../../types/campaigns'

const CHANNEL_COLORS: Record<CampaignChannel, string> = {
  SMS: 'badge-light-primary',
  EMAIL: 'badge-light-info',
  WHATSAPP: 'badge-light-success',
  TELEGRAM: 'badge-light-warning',
}

const CHANNEL_LABELS: Record<CampaignChannel, string> = {
  SMS: 'SMS',
  EMAIL: 'Email',
  WHATSAPP: 'WhatsApp',
  TELEGRAM: 'Telegram',
}

type Props = {
  channel: CampaignChannel | string
}

export const ChannelBadge = ({channel}: Props) => {
  const normalized = (channel?.toUpperCase?.() as CampaignChannel) ?? 'SMS'
  const color = CHANNEL_COLORS[normalized] ?? 'badge-light-secondary'
  return <span className={clsx('badge fw-bold me-2', color)}>{CHANNEL_LABELS[normalized] ?? normalized}</span>
}
